import { useFormikContext } from "formik";
import InputFormik from "../../../../../common/components/form/InputFormik";
import getAddressByZipCode from "../../../../../common/services/viacep";
import ComboBoxFormik from "../../../../../common/components/form/ComboBoxFormik";
import { maskCEP } from "../../../../../common/helpers/mask.helpers";


const AddressFields: React.FC = () => {
    const formik = useFormikContext();

    return (
        <div>
            <div className="flex flex-col sm:flex-row gap-3">
                <div className="flex-shrink-0 w-full sm:max-w-[150px] text-sm lg:text-lg">
                    <InputFormik
                        required={true}
                        name="address.zipcode"
                        label="CEP:"
                        mask={maskCEP}
                        onChange={async (e) => {
                            formik.handleChange(e)

                            const value = e.target.value;

                            if (value.replace(/\D/g, '').length === 8) {
                                const address = await getAddressByZipCode(value);
                                if (address) {
                                    formik.setFieldValue('address.street', address.street);
                                    formik.setFieldValue('address.district', address.neighbourhood);
                                    formik.setFieldValue('address.city', address.city);
                                    formik.setFieldValue('address.state', address.state);
                                    formik.setFieldValue('address.latitude', 0);
                                    formik.setFieldValue('address.longitude', 0);
                                }
                            }
                        }}
                    />
                </div>
                <div className="w-full sm:w-5/6 mb-4">
                    <InputFormik
                        required={true}
                        name="address.street"
                        label="Endereço:"
                        placeholder="Rua"
                    />
                </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
                <InputFormik
                    required={true}
                    name="address.number"
                    label="Número:"
                    placeholder="Número"
                    className="w-full sm:max-w-[150px]"
                />
                <InputFormik
                    name="address.complement"
                    label="Complemento:"
                    placeholder="complemento"
                    className="w-full sm:w-5/6 mb-4"
                />
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
                <ComboBoxFormik
                    required={true}
                    name="address.state"
                    label="Estado:"
                    options={[
                        { value: "", label: "-" },
                        { value: "AC", label: "Acre" },
                        { value: "AL", label: "Alagoas" },
                        { value: "AP", label: "Amapá" },
                        { value: "AM", label: "Amazonas" },
                        { value: "BA", label: "Bahia" },
                        { value: "CE", label: "Ceará" },
                        { value: "DF", label: "Distrito Federal" },
                        { value: "ES", label: "Espírito Santo" },
                        { value: "GO", label: "Goiás" },
                        { value: "MA", label: "Maranhão" },
                        { value: "MT", label: "Mato Grosso" },
                        { value: "MS", label: "Mato Grosso do Sul" },
                        { value: "MG", label: "Minas Gerais" },
                        { value: "PA", label: "Pará" },
                        { value: "PB", label: "Paraíba" },
                        { value: "PR", label: "Paraná" },
                        { value: "PE", label: "Pernambuco" },
                        { value: "PI", label: "Piauí" },
                        { value: "RJ", label: "Rio de Janeiro" },
                        { value: "RN", label: "Rio Grande do Norte" },
                        { value: "RS", label: "Rio Grande do Sul" },
                        { value: "RO", label: "Rondônia" },
                        { value: "RR", label: "Roraima" },
                        { value: "SC", label: "Santa Catarina" },
                        { value: "SP", label: "São Paulo" },
                        { value: "SE", label: "Sergipe" },
                        { value: "TO", label: "Tocantins" },
                    ]}
                    className="w-full "
                />
                <InputFormik
                    required={true}
                    name="address.city"
                    label="Cidade:"
                    placeholder="cidade"
                    className="w-full"
                />
                <InputFormik
                    required={true}
                    name="address.district"
                    label="Bairro:"
                    placeholder="bairro"
                    className="w-full"
                />

                <InputFormik
                    required={false}
                    name="address.municipalyCode"
                    label="Código do Municipio:"
                    placeholder="Código do municipio"
                    className="w-full"
                />
            </div>
        </div>
    )
}

export default AddressFields;
